const PAGE_CONTAINER_TOP_OFFSET = 80

export const scrollToTopOfPageContainer = (
  pageContainerRef: React.RefObject<HTMLDivElement>,
) => {
  const pageContainerElement = pageContainerRef.current
  if (pageContainerElement) {
    const top =
      pageContainerElement.getBoundingClientRect().top +
      window.scrollY -
      PAGE_CONTAINER_TOP_OFFSET
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
  }
}
